import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";

import DebouncedTextField from "../../components/DebouncedTextField";
import useAssessmentLabel from "../../hooks/useAssessmentLabel";

// @ts-expect-error - css
import styles from "./Assessment.module.css";

interface OthersInterface {
  label?: string;
  assessmentOthers?: string;
  onChange: (value: string) => void;
}

const MAX_LENGTH = 2000;

const Others: React.FC<OthersInterface> = (props) => {
  const { assessmentOthers = "", onChange } = props;
  const assessmentLabels = useAssessmentLabel();

  const [value, setValue] = useState(assessmentOthers || "");

  const isError = value.length > MAX_LENGTH;

  useEffect(() => {
    setValue(assessmentOthers || "");
  }, [assessmentOthers]);

  return (
    <Box className={styles.assessmentRow}>
      <Box className={styles.assessmentLabel}>
        <Typography component="span" fontWeight="600">
          {props?.label || assessmentLabels.others}
        </Typography>
      </Box>
      <Box className={styles.assessmentField} display="flex">
        <DebouncedTextField
          data-testmation="othersTextField"
          fullWidth
          variant="outlined"
          margin="dense"
          debounceAt={400}
          slotProps={{
            inputLabel: { shrink: true },
            htmlInput: {
              maxLength: MAX_LENGTH
            },
            formHelperText: { style: { position: "absolute", right: 0, bottom: 0, margin: 5 } }
          }}
          label={assessmentLabels.others || "Others"}
          placeholder="Enter other observations"
          multiline
          maxRows={4}
          value={value}
          onChange={(e) => {
            setValue(e.target.value);
            onChange(e.target.value);
          }}
          error={isError}
          onFocus={(e) => e.target.select()}
          helperText={`${value.length}/${MAX_LENGTH}`}
        />
      </Box>
    </Box>
  );
};

export default Others;
